const DLMP01V101 = async () => await import('@/views/dlmp/DLMP-01-V101.vue')
const DLMP02V101 = async () => await import('@/views/dlmp/DLMP-02-V101.vue')
const DLMP03V101 = async () => await import('@/views/dlmp/DLMP-03-V101.vue')
const DLMP04V101 = async () => await import('@/views/dlmp/DLMP-04-V101.vue')
const DLMP05V101 = async () => await import('@/views/dlmp/DLMP-05-V101.vue')

export const routerDlmp = [
  {
    path: '/dlmp/DLMP-01-V101',
    component: DLMP01V101,
    name: 'DLMP-01-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: true
      },
      title: '마이페이지',
      code: 'DLMP-01-V101',
      tabName: '마이페이지'
    }
  },
  {
    path: '/dlmp/DLMP-02-V101',
    component: DLMP02V101,
    name: 'DLMP-02-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: true,
        home: false
      },
      title: '과거 배송 이력',
      code: 'DLMP-02-V101',
      tabName: '과거 배송 이력'
    }
  },
  {
    path: '/dlmp/DLMP-03-V101',
    component: DLMP03V101,
    name: 'DLMP-03-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: true,
        home: false
      },
      title: '배송신청(수기접수)',
      code: 'DLMP-03-V101',
      tabName: '배송신청(수기접수)'
    }
  },
  {
    path: '/dlmp/DLMP-04-V101',
    component: DLMP04V101,
    name: 'DLMP-04-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: true,
        home: false
      },
      title: '공지사항',
      code: 'DLMP-03-V101',
      tabName: '공지사항'
    }
  },
  {
    path: '/dlmp/DLMP-05-V101',
    component: DLMP05V101,
    name: 'DLMP-05-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '비밀번호 변경',
      code: 'DLMP-03-V101',
      tabName: '비밀번호 변경'
    }
  }
]
